import * as React from "react";

import { DatasheetFieldComponentGetDto } from "@common/dto/datasheet/field-component/get-dto";
import { IDatasheetResultElement } from "@modules/datasheets/components/result/types/datasheet-element";
import {
  getCommonFieldBasedElementParams,
  useDatasheetElementController,
} from "@modules/datasheets/components/result/controllers/datasheet-element";
import { trDts } from "@modules/datasheets/utils/i18n";

export type LookupTableOption = {
  value: string | number;
  label: string;
};

export type LookupTableColumn = {
  header: string;
  accessorKey: keyof LookupTableOption;
};

export type LookupTableFieldProps = IDatasheetResultElement<DatasheetFieldComponentGetDto>;

export const useLookupTableFieldController = (props: LookupTableFieldProps) => {
  const { datasheetElement, onChange } = props;

  const [menuOpened, setMenuOpened] = React.useState(false);

  const DROPDOWN_PLACEHOLDER = " ";

  const { headingSizeDependencies, headingPlacedHorizontally, headingPosition } =
    getCommonFieldBasedElementParams(props);

  const baseDatasheetElementController = useDatasheetElementController(props, { headingSizeDependencies });

  const normalizeDropdownOptions = React.useMemo<Array<{ value: string }>>(() => {
    return [];
    // if (!datasheetElement.original.field.options?.length) {
    //   return [];
    // }

    // return datasheetElement.original.field.options.map((option) => ({
    //   value: option.actualValue,
    //   label: option.displayValue,
    // }));
  }, []);

  const selectedItem = React.useMemo<{ label: string; value: string } | undefined>(
    // () => normalizeDropdownOptions.find(({ value }) => value == datasheetElement.original.field.value),
    () => undefined,
    [normalizeDropdownOptions]
  );

  // TODO: It should come from BE
  const columns: Array<LookupTableColumn> = React.useMemo(
    () => [
      { header: trDts("State"), accessorKey: "value" },
      { header: trDts("StTerrProvName"), accessorKey: "label" },
    ],
    []
  );

  const handleOpenMenu = React.useCallback(() => {
    setMenuOpened(true);
  }, []);

  const handleCloseMenu = React.useCallback(() => {
    setMenuOpened(false);
  }, []);

  const handleLookupTableFieldValueChange = React.useCallback(
    (value: LookupTableOption["value"]) => {
      handleCloseMenu();

      onChange(datasheetElement.id, {
        ...datasheetElement,
        original: {
          ...datasheetElement.original,
          field: {
            ...datasheetElement.original.field,
            value,
          },
        },
      });
    },
    [datasheetElement, onChange, handleCloseMenu]
  );

  return {
    handleLookupTableFieldValueChange,
    handleOpenMenu,
    handleCloseMenu,
    headingPosition,
    headingPlacedHorizontally,
    menuOpened,
    columns,
    selectedItem,
    normalizeDropdownOptions,
    DROPDOWN_PLACEHOLDER,
    ...baseDatasheetElementController,
  };
};
